export class StoreCoverage {
  storeCoverageID!: number;
  title!: string;
  category!: number;
  categoryName!: string;
  storeCoverageDate!: Date | null;
  storeCoverageDateStr?: string | null;
  fileName!: string;
  base64String!: string;
  createdBy!: number;
  createdDate!: Date;
  updatedBy?: number;
  updatedDate?: Date;
}

export class StoreCoverageFilterCriteria 
{
    title?: string;
    categoryName?: string;
    storeCoverageDate1?: string;
    storeCoverageDate2?: string;
}